import {
  COOKIE_KEY_FOR_SERVER_SIDE_SUBSCRIPTION_CHECK,
  ENCODED_COOKIE_VALUES_FOR_SERVER_SIDE_SUBSCRIPTION_CHECK,
} from 'constants/ai'
import Cookie from 'js-cookie'

/**
 * Client-side function to set user subscription cookie
 * Uses encoded values for privacy. This should only be called on the client side.
 * @param isSubscriber - Whether the user is a subscriber
 * @returns void
 */

export const setSubscriptionStatusToCookie = (isSubscriber: boolean): void => {
  if (typeof window === 'undefined') {
    console.warn('setSubscriptionStatusToCookie should only be called on the client side')
    return
  }

  Cookie.set(
    COOKIE_KEY_FOR_SERVER_SIDE_SUBSCRIPTION_CHECK,
    isSubscriber
      ? ENCODED_COOKIE_VALUES_FOR_SERVER_SIDE_SUBSCRIPTION_CHECK.ACTIVE
      : ENCODED_COOKIE_VALUES_FOR_SERVER_SIDE_SUBSCRIPTION_CHECK.INACTIVE,
    {
      expires: 365, // 1 year
      sameSite: 'lax',
      secure: false,
      path: '/',
    }
  )
}
